export const QUERY_PAYABLES = "QUERY_PAYABLES";
